export default __webpack_public_path__ + "static/media/slav_xl.0a078ca8.jpg";